var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import Avatar from 'antd/lib/avatar';
import Select from 'antd/lib/select';
import 'antd/lib/avatar/style/index.css';
import 'antd/lib/select/style/index.css';
var selfStyles = require('./styles.scss');
var MenuWorkspaceEventSelect = (function (_super) {
    __extends(MenuWorkspaceEventSelect, _super);
    function MenuWorkspaceEventSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.handleNavigateToEvent = _this.handleNavigateToEvent.bind(_this);
        return _this;
    }
    MenuWorkspaceEventSelect.prototype.handleNavigateToEvent = function (value) {
        this.props.dispatch(push("/event/" + value));
    };
    MenuWorkspaceEventSelect.prototype.render = function () {
        return (React.createElement("div", { id: 'MenuWorkspaceEventSelectWrapper' },
            React.createElement(Select, { size: 'large', className: selfStyles.menuSelect, getPopupContainer: function () { return document.getElementById('MenuWorkspaceEventSelectWrapper'); }, value: this.props.match.params.subdomain, onSelect: this.handleNavigateToEvent, placeholder: 'Go to an event!' },
                this.props.events
                    .sort(function (a, b) { return b.dateStart.localeCompare(a.dateStart); })
                    .map(function (e) { return (React.createElement(Select.Option, { key: e.subdomain, value: e.subdomain },
                    React.createElement("div", { className: selfStyles.menuOption },
                        React.createElement(Avatar, { shape: 'square', size: 'small', src: e.logoUrl || e.logoIdenticon, className: selfStyles.menuOptionAvatar }),
                        React.createElement("span", { className: selfStyles.menuItemText }, e.nameShort)))); }),
                React.createElement(Select.Option, { key: 'new', value: 'new' },
                    React.createElement("div", { className: selfStyles.menuOption },
                        React.createElement(Avatar, { shape: 'circle', size: 'small', icon: 'plus', className: selfStyles.menuOptionAvatar }),
                        React.createElement("span", { className: selfStyles.menuItemText }, "Setup a new event"))))));
    };
    return MenuWorkspaceEventSelect;
}(React.Component));
export default connect()(MenuWorkspaceEventSelect);



//////////////////
// WEBPACK FOOTER
// ./src/pages/templates/components/PageMenu/MenuWorkspaceEventSelect.tsx
// module id = 809
// module chunks = 0